"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPresenter = void 0;
var react_1 = __importStar(require("react"));
var Loader_1 = require("../../Loader");
var FocusHelper_1 = require("./FocusHelper");
var SelectComponents_1 = require("./SelectComponents");
var SelectSearchInput_1 = require("./SelectSearchInput");
var SelectUtils_1 = require("../SelectUtils");
var useFocus_1 = require("../hooks/useFocus");
var useHighlightedOption_1 = require("../hooks/useHighlightedOption");
var useListKeyboardNavigation_1 = require("../hooks/useListKeyboardNavigation");
var UseSelectUtils_1 = require("../hooks/UseSelectUtils");
var SelectPresenter = function (props) {
    var _a;
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = react_1.useState(""), searchQuery = _c[0], setSearchQuery = _c[1];
    var _d = react_1.useState(false), isAdding = _d[0], setIsAdding = _d[1];
    /**
     * When a users presses Tab in a search panel, we intercept it and prevent the
     * browser from tabbing normally. This is because the search input is part of the
     * panel which is in a React portal, and high up in the DOM. Left to it's own
     * behaviour, tab then cycles to the very first link on the page, nowhere near the
     * form the user thinks they're in.
     *
     * However after close we need to refocus on the focus helper - so we need to
     * track when the drop down is closed and steal focus once more.
     */
    var justClosed = react_1.useRef(false);
    var focusRef = react_1.useRef(null);
    var _e = useFocus_1.useFocus({
        autoFocus: props.autoFocus,
        ref: focusRef,
    }), isFocussed = _e.isFocussed, stealFocus = _e.stealFocus, onFocus = _e.onFocus, onBlur = _e.onBlur;
    react_1.useEffect(function () {
        if (justClosed.current) {
            // Make sure focus moves to the focus helper when closing. If the drop down
            // contained a search, tab focus might move to the first link on the page
            // (see above discussion about react portals)
            stealFocus();
        }
        justClosed.current = false;
    }, [focusRef.current]);
    var components = __assign(__assign({}, SelectComponents_1.defaultSelectComponents), props.components);
    var OuterMostContainer = components.OuterMostContainer, CollapsedControlContainer = components.CollapsedControlContainer, DropDownContainer = components.DropDownContainer, Option = components.Option, OptionContainer = components.OptionContainer, Value = components.Value, ValueContainer = components.ValueContainer, OptionsPanel = components.OptionsPanel, AddInvitationControl = components.AddInvitationControl, AddControl = components.AddControl;
    var onOpen = function () {
        if (props.disabled) {
            if (isOpen) {
                onClose();
            }
            return;
        }
        if (!props.multiple && props.selectedOptions.length === 1) {
            highlightOption(props.selectedOptions[0]);
        }
        stealFocus();
        setIsAdding(false);
        setIsOpen(true);
        if (props.searchable) {
            // The autofocus prop on the search input doesn't kick in as the page has rendered.
            // Also calling stealFocus() doesn't work as until setIsOpen() kicks in the
            // focusRef is pointing at the focus helper not the esaerch input.
            //
            // This just puts steakFocus on the bottom of the event loop to ensure the ref is
            // pointing at the right place.
            setTimeout(stealFocus, 50);
        }
    };
    var onClose = function () {
        justClosed.current = true;
        // If search isn't inline, then reset it
        if (props.searchable && !props.inlineSearch) {
            onSearchChange("", true);
        }
        setIsOpen(false);
    };
    var onSelect = function (option) {
        props.onSelect(option);
        if (!props.multiple) {
            onClose();
            stealFocus();
            removeHighlight();
        }
        calculateControlWidth();
    };
    var onItemAdded = function (value) {
        if (value) {
            props.addValue(value);
            onClose();
        }
        setIsAdding(false);
    };
    // CONTROL EVENT HANDLING
    var _f = react_1.useState(), controlEl = _f[0], setControlEl = _f[1];
    var onControlMouseDown = function (e) {
        if (!isOpen) {
            onOpen();
            e.preventDefault();
        }
        else if (!props.interactiveControl && !props.inlineSearch) {
            onClose();
        }
    };
    var _g = useHighlightedOption_1.useHighlightedOption({
        options: UseSelectUtils_1.flattenOptions(props.options),
    }), highlightedOption = _g.highlightedOption, highlightOption = _g.highlightOption, removeHighlight = _g.removeHighlight, highlightNextOption = _g.highlightNextOption;
    var onKeyDown = useListKeyboardNavigation_1.useListKeyboardNavigation({
        disabled: !!props.disabled,
        textInputActive: !!props.searchable || !!props.inlineSearch,
        onActivationKeyPress: function () {
            if (highlightedOption) {
                onSelect(highlightedOption);
            }
        },
        onArrowNavigation: function (key, e) {
            if (!isOpen) {
                e.preventDefault();
                onOpen();
            }
            else {
                highlightNextOption(key);
            }
        },
        onNavigationAway: function (e) {
            if (isOpen) {
                if (highlightedOption) {
                    // Prevent moving focus until the next key press
                    e.preventDefault();
                    onSelect(highlightedOption);
                }
                onClose();
            }
        },
        onRemoveKeyPress: function (e) {
            var lastItem = props.selectedOptions[props.selectedOptions.length - 1];
            var queryIsEmpty = searchQuery.length === 0;
            if (lastItem && queryIsEmpty) {
                onSelect(lastItem);
                stealFocus();
            }
        },
        onUnhandledKeyPress: removeHighlight,
    }).onKeyDown;
    // SELECT STYLES
    var dropdownRef = react_1.useRef(null);
    var valueContainerRef = react_1.useRef(null);
    var addControlRef = react_1.useRef(null);
    var _h = react_1.useState(), controlWidth = _h[0], setControlWidth = _h[1];
    var _j = react_1.useState(false), calculatingWidth = _j[0], setCalculatingWidth = _j[1];
    react_1.useEffect(function () {
        // If the options change - then we might need to get bigger (though checkout
        // calculateControlWidth - we can't get smaller)
        calculateControlWidth();
    }, [props.options, controlEl, dropdownRef.current, valueContainerRef.current, isAdding]);
    var measureNaturalWidth = function (el) {
        var clone = el.cloneNode(true);
        clone.style.position = "absolute";
        clone.style.width = "auto";
        clone.style.visibility = "hidden";
        document.body.appendChild(clone);
        var naturalValueWidth = clone.getBoundingClientRect().width;
        document.body.removeChild(clone);
        return naturalValueWidth;
    };
    var calculateControlWidth = function () {
        var _a;
        // Get the width of the invisible dropdown
        var dropDownWidth = dropdownRef.current ? measureNaturalWidth(dropdownRef.current) : 0;
        var valueWidth = valueContainerRef.current
            ? valueContainerRef.current.getBoundingClientRect().width
            : 0;
        // Get the width of the value container - but cloned and made absolute so we
        // find out it's natural width - the width it would be if unconstrained.
        var naturalValueWidth = valueContainerRef.current
            ? measureNaturalWidth(valueContainerRef.current)
            : 0;
        var naturalAddControlWidth = addControlRef.current
            ? measureNaturalWidth(addControlRef.current)
            : 0;
        // Calculate the original 'padding' caused by control padding - this is our
        // default additional width we need to add back.
        var defaultWidthModifier = (controlEl ? controlEl.getBoundingClientRect().width : 0) - valueWidth;
        var modifier = (_a = props.widthModifier) !== null && _a !== void 0 ? _a : 0;
        /**
         * If the width of the invisible dropdown is larger than the width of the control as it is now, then set the
         * control width. Otherwise keep it as is.
         */
        setControlWidth(Math.max(220, // Below this, selects are just ackward
        controlWidth !== null && controlWidth !== void 0 ? controlWidth : 0, // Don't get smaller
        dropDownWidth, // Width of the drop down items
        naturalValueWidth + defaultWidthModifier, // Width of the value area,
        naturalAddControlWidth // The width of the add control (if visible)
        ) + modifier);
    };
    var classes = [
        props.fill && "+fill",
        (isFocussed || isOpen) && "+focus",
        props.disabled && "+disabled",
        props.className,
    ].filter(function (item) { return !!item; });
    var handleFocus = function () {
        onFocus();
        if (props.openOnFocus) {
            onOpen();
        }
    };
    /**
     *
     * @param newQuery
     * @param closing When the select is closing this is called to reset the text in the search but
     *                we don't want to refetch options.
     * @returns
     */
    var onSearchChange = function (newQuery, closing) {
        if (closing === void 0) { closing = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (props.disabled) {
                            return [2 /*return*/];
                        }
                        setSearchQuery(newQuery);
                        if (!props.onInputChange) return [3 /*break*/, 2];
                        return [4 /*yield*/, props.onInputChange(newQuery)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!closing) {
                            if (!isOpen) {
                                onOpen();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var renderGroup = function (group) {
        if (!group.options || group.options.length === 0) {
            return null;
        }
        return __spreadArray([
            react_1.default.createElement("li", { className: "c-dropdown__item +group-header" }, group.heading)
        ], group.options.map(renderOption));
    };
    var renderOption = function (option, index) {
        var _a;
        var isHighlighted = option === highlightedOption;
        var selected = UseSelectUtils_1.isValueOrItemInOptionsList(props.selectedOptions, option.value);
        if (selected && props.hideOptionOnSelection) {
            return null;
        }
        return (react_1.default.createElement(OptionContainer, { isHighlighted: isHighlighted, isDisabled: option.disabled, onSelect: function () { return onSelect(option); }, onMouseEnter: function () { return highlightOption(option); }, key: "select-option-" + index + "-" + option.value },
            react_1.default.createElement(Option, { onSelect: function () { return onSelect(option); }, multiple: (_a = props.multiple) !== null && _a !== void 0 ? _a : false, option: option, isHighlighted: isHighlighted, isSelected: selected, isDisabled: option.disabled })));
    };
    var addContent;
    var inviteAdditionContent;
    if (props.inviteAdditions) {
        inviteAdditionContent = (react_1.default.createElement(AddInvitationControl, { onStartAdding: function () { return setIsAdding(true); } }, (_a = props.inviteAdditionsContent) !== null && _a !== void 0 ? _a : (react_1.default.createElement("span", null,
            react_1.default.createElement("span", { className: "c-button__icon" }, "+"),
            " ",
            react_1.default.createElement("span", { className: "c-button__text" }, "Add")))));
        addContent = (react_1.default.createElement(AddControl, { mRef: addControlRef, onAdded: onItemAdded, onAddFromInlineValue: function (value) { return __awaiter(void 0, void 0, void 0, function () {
                var result;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = props.onInlineAdd) === null || _a === void 0 ? void 0 : _a.call(props, value))];
                        case 1:
                            result = _b.sent();
                            onItemAdded(result);
                            return [2 /*return*/];
                    }
                });
            }); }, onCancel: function () { return setIsAdding(false); } }));
        if (props.inviteAdditions == "inline") {
            // Simple add interfaces show inline
            // Note the onKeyDown is to prevent Tab being handled by the list navigation
            // hook and trying to close the select.
            addContent = (react_1.default.createElement("div", { onKeyDown: function (e) { return e.stopPropagation(); }, className: "c-dropdown__footer", ref: addControlRef }, addContent));
            if (isAdding) {
                inviteAdditionContent = addContent;
            }
        }
        else {
            if (isAdding) {
                // Note the onKeyDown is to prevent Tab being handled by the list navigation
                // hook and trying to close the select.
                inviteAdditionContent = (react_1.default.createElement("div", { onKeyDown: function (e) { return e.stopPropagation(); } },
                    addContent,
                    inviteAdditionContent));
            }
        }
    }
    return (react_1.default.createElement(OuterMostContainer, null,
        react_1.default.createElement(CollapsedControlContainer, { ref: setControlEl, onMouseDown: onControlMouseDown, className: classes.join(" "), style: props.fill ? undefined : { width: controlWidth }, onKeyDown: onKeyDown },
            react_1.default.createElement(ValueContainer, { ref: valueContainerRef },
                (!props.searchable || !isOpen) && !props.inlineSearch && (react_1.default.createElement(FocusHelper_1.FocusHelper, { ref: focusRef, name: props.name, id: props.name, onBlur: onBlur, onFocus: handleFocus, onKeyPress: function (e) {
                        if (!isOpen) {
                            onOpen();
                        }
                    } })),
                props.selectedOptions.length === 0 &&
                    (props.inlineSearch ? searchQuery.length === 0 : true) ? (react_1.default.createElement("span", { className: "u-color-light", style: { pointerEvents: "none" } }, props.placeholderText || "Select an item")) : (props.selectedOptions.map(function (option, index) { return (react_1.default.createElement(Value, __assign({}, props.selectValueProps, { option: option, onOptionSelect: onSelect, className: "c-dropdown__selected-option", key: "select-value-" + index + "-" + option.value }), SelectUtils_1.formatOption(option))); })),
                props.inlineSearch && (react_1.default.createElement("input", { ref: focusRef, tabIndex: -1, onChange: function (e) { return onSearchChange(e.target.value); }, onFocus: handleFocus, value: searchQuery, size: searchQuery.length || 1, type: "text", className: "c-input", style: {
                        background: 0,
                        border: 0,
                        fontSize: "inherit",
                        marginLeft: "5px",
                    } })))),
        react_1.default.createElement(OptionsPanel, { isOpen: isOpen || calculatingWidth, anchorElement: controlEl, onRequestClose: function () { return onClose(); }, anchorElementClickable: props.interactiveControl, disableXSnapping: true, 
            // Don't control panel size if the width is being calculated
            panelSize: {
                width: calculatingWidth ? "auto" : controlWidth ? controlWidth + "px" : "auto",
                height: "auto",
            }, 
            // Allow clicks elsewhere on the screen while calculating the width of the control
            preventDismissByClickAway: calculatingWidth, onKeyDown: onKeyDown },
            react_1.default.createElement(DropDownContainer, __assign({}, props.dropDownContainerProps, { searchable: props.searchable, ref: dropdownRef, removeHighlight: removeHighlight, searchContent: react_1.default.createElement(react_1.default.Fragment, null, ((props.searchable && !props.inlineSearch) || props.canSelectAll) && (react_1.default.createElement("div", { className: "c-dropdown__header" },
                    props.searchable && !props.inlineSearch && (react_1.default.createElement(SelectSearchInput_1.SelectSearchInput, { ref: focusRef, autoFocus: true, name: props.name, id: props.name, onChange: function (e) { return onSearchChange(e.target.value); }, value: searchQuery, placeholder: "Search" })),
                    props.canSelectAll && (react_1.default.createElement("label", { className: "c-label" },
                        react_1.default.createElement("input", { className: "c-input", type: "checkbox", onChange: props.onSelectAll, checked: props.isAllSelected }),
                        "Select All"))))), footerContent: inviteAdditionContent }),
                !props.hideLoader && props.loading ? (react_1.default.createElement("div", { className: "c-alert +align-start c-dropdown__alert +loading", role: "alert" },
                    react_1.default.createElement("span", { className: "c-alert__icon" },
                        react_1.default.createElement(Loader_1.Loader, null)),
                    react_1.default.createElement("span", { className: "c-alert__text" }, "Loading..."))) : props.options.length === 0 ? (react_1.default.createElement("div", { className: "c-alert c-dropdown__alert +none-found" }, searchQuery
                    ? props.noOptionsFoundText || "No matches found"
                    : props.noOptionsText || "No matches available")) : (props.options
                    .map(function (option, index) {
                    if (option) {
                        if ("options" in option) {
                            return renderGroup(option);
                        }
                        else {
                            return renderOption(option, index);
                        }
                    }
                })
                    .filter(function (option) { return option !== null; })),
                props.selectedOptions.length > 0 && props.clearable && (react_1.default.createElement("div", { className: "c-dropdown__footer" },
                    react_1.default.createElement("button", { className: "c-button +ghost +small", onClick: function () {
                            if (props.onClearSelection) {
                                props.onClearSelection();
                                stealFocus();
                            }
                        } }, "Clear selection")))))));
};
exports.SelectPresenter = SelectPresenter;
//# sourceMappingURL=SelectPresenter.js.map